export default "__VITE_ASSET__BM$K5EGI__"